var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"projects-move",attrs:{"role":"button"},on:{"click":_vm.movingProject}},[_c('i',{staticClass:"far fa-folder-open"}),_vm._v(" "+_vm._s(_vm.favorite.project ? _vm.favorite.project.name : 'non défini')+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }